export const CommonSummaryTexts = {
  buttonTitle: 'Сохранить',
};
